import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../store';
import {
  exchangeCodeForTokens,
  setAuthError,
} from '../../../lib/redux/sheets/slice';

const GOOGLE_SCOPE = 'https://www.googleapis.com/auth/drive.file';

export function GoogleSignInButton() {
  const dispatch = useDispatch();
  const auth = useSelector((state: RootState) => state.googleSheets.auth);

  const login = useGoogleLogin({
    scope: GOOGLE_SCOPE,
    flow: 'auth-code',
    onSuccess: async (codeResponse) => {
      const success = await exchangeCodeForTokens(dispatch, codeResponse.code, window.location.origin);
      if (!success) {
        dispatch(setAuthError('Failed to exchange code for tokens'));
      }
    },
    onError: (errorResponse) => {
      const message = (errorResponse as any).error_description || (errorResponse as any).error || 'Google login failed.';
      dispatch(setAuthError(message));
    },
  });

  return (
    <div className="space-y-4">
      {auth.statusMessage && <div className="text-center text-blue-500">{auth.statusMessage}</div>}
      {auth.authError && <div className="text-center text-red-500">{auth.authError}</div>}
      <div className="text-center">
        <h3 className="text-lg font-medium text-gray-900 mb-2">Connect Google Sheets</h3>
        <p className="text-sm text-gray-600 mb-4">Sign in to access your spreadsheet</p>
      </div>
      <button
        onClick={() => login()} 
        className="w-full inline-flex items-center justify-center px-4 py-3 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Sign in with Google
      </button>
    </div>
  );
} 